import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins/emoticons.min.css';
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/js/plugins/align.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/js/plugins/colors.min';
import 'froala-editor/js/plugins/emoticons.min';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/font_size.min';
import 'froala-editor/js/plugins/image.min';
import 'froala-editor/js/plugins/line_breaker.min';
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/js/plugins/lists.min';
import 'froala-editor/js/plugins/table.min';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import { eq, map, join, startCase, camelCase, toLower, size, compact, filter } from 'lodash';
import { string, number, bool, shape, arrayOf, oneOfType } from 'prop-types';
import { ui, useResizeDetector } from 'envy-ui';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import $ from 'jquery';
import FroalaEditor from 'react-froala-wysiwyg';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import ga4 from 'react-ga4';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';
import React, { useState, Profiler, useEffect } from 'react';
import ReactGA from 'react-ga';
import solidGauge from 'highcharts/modules/solid-gauge';
import Accessibility from 'highcharts/modules/accessibility';
import { PAGE_VIEW } from '../../graphqls';
import { Ticker, Footer } from '.';
import Card from './card';
import Header from './header';
import onRender from '../../util/onRender';

highchartsMore(Highcharts);
solidGauge(Highcharts);
Accessibility(Highcharts);

export const backgroundBlendModes = [
  { label: 'Normal', value: 'normal' },
  {},
  { label: 'Darken', value: 'darken' },
  { label: 'Multiply', value: 'multiply' },
  {},
  { label: 'Lighten', value: 'lighten' },
  { label: 'Screen', value: 'screen' },
  { label: 'Color Dodge', value: 'color-dodge' },
  {},
  { label: 'Overlay', value: 'overlay' },
  { label: 'Soft Light', value: 'soft-light' },
  { label: 'Hard Light', value: 'hard-light' },
  {},
  // { label: 'Hue', value: 'hue' },
  { label: 'Luminosity', value: 'luminosity' },

  // { label: 'Saturation', value: 'saturation' },
];
export default function Homepage({
  isPublic,
  linkPrefix,
  branding,
  navs,
  data: {
    banner: {
      image: bannerImage = '',
      position: backgroundPosition = 'center',
      backgroundColor: bannerBackgroundColor,
      text: bannerText,
      enable: hasBanner,
      withImage,
      opacity = 1,
      textDecoration,
      textDecorationColor,
      imageBlendMode,
    } = {},
    children = [],
    columns,
    headerPosition,
    navTextColor: homepageNavTextColor,
    introContent = [],
    mainContentBackgroundColor,
    newsFeed: { feed = [], enabled: showNews = true, position: newsPosition, title: newsTitle, backgroundColor: newsBackgroundColor } = {},
    overlapCardTitle,
    showCardDescription = true,
    showProgress,
    subContent = [],
  } = {},
  settings,
  settings: {
    // bannerHeight = 0,
    bannerHeight = 0,
    completed: completedLabel = '',
    completedCount = 0,
    cssOverwrite,
    customFields,
    discontinued: discontinuedLabel = '',
    discontinuedCount = 0,
    fontFamily,
    fontSize,
    footer: footerContent,
    footerBackgroundColor,
    googleTracking = [],
    translateProvider = 'NONE',
    headerBackgroundColor,
    horizontalPadding = '',
    logo: { image: logo } = {},
    logoLink,
    majorDisruption: majorDisruptionLabel = '',
    majorDisruptionCount = 0,
    name: corporationName = '',
    navPosition = 'none',
    navTextColor = 'rgba(255,255,255,1)',
    onTrack: onTrackLabel = '',
    onTrackCount = 0,
    overdueCount = 0,
    progressPercentage = 0,
    showCompleted,
    showCustomFields,
    showDiscontinued,
    showMajorDisruption,
    showMinorDisruption,
    showOnTrack,
    showStatusPending,
    showTags,
    showUpcoming,
    someDisruption: someDisruptionLabel = '',
    someDisruptionCount = 0,
    statusPending: statusPendingLabel = '',
    statusPendingCount = 0,
    tags,
    upcoming: upcomingLabel = '',
    upcomingCount = 0,
    showStatusBar = false,
  } = {},
  name,
  planName,
}) {
  const { width, ref } = useResizeDetector();
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTable] = useState(false);
  const { pathname: page } = useLocation();
  const [onPageView] = useMutation(PAGE_VIEW);
  const statusCount =
    (showOnTrack ? onTrackCount : 0) +
    (showMinorDisruption ? someDisruptionCount : 0) +
    (showMajorDisruption ? majorDisruptionCount : 0) +
    (showStatusPending ? statusPendingCount : 0) +
    (showCompleted ? completedCount : 0) +
    (showDiscontinued ? discontinuedCount : 0) +
    (showUpcoming ? upcomingCount : 0);
  const onTrackColor = '#57a92b';
  const someDisruptionColor = '#ffd700';
  const majorDisruptionColor = '#e30022';
  const completedColor = '#1565C0';
  const discontinuedColor = '#36312d';
  const upcomingColor = '#8b65a1';
  const statusPendingColor = '#8c8b8c';
  const isMeaningful = (value) => !!value && Math.round((value / statusCount) * 100) > 0;
  const resizeImages = () => {
    const cards = $(
      '.column-row-1 .child-img, .column-row-2 .child-img, .column-row-3 .child-img, .column-row-4 .child-img, .column-row-5 .child-img',
    );
    const cs = $('iframe')
      .contents()
      .find(
        '.column-row-1 .child-img, .column-row-2 .child-img, .column-row-3 .child-img, .column-row-4 .child-img, .column-row-5 .child-img',
      );
    cards.height(cards.width() / 2);
    cs.height(cs.width() / 2);
    let bannerHeightDelta = 0;
    let bannerHeight = 420;
    let bHeight = 420;
    const banner = $('.intro');
    const b = $('iframe').contents().find('.intro');

    if (b.width() <= 768 || (banner.width() <= 768 && bannerHeight)) {
      setIsTable(true);
      bannerHeightDelta = banner.width() / 8 || b.width() / 8;
    } else {
      setIsTable(false);
    }

    if (b.width() <= 390 || (banner.width() <= 390 && bannerHeight)) {
      setIsMobile(true);
      bannerHeightDelta = banner.width() / 3 || b.width() / 3;
    } else {
      setIsMobile(false);
      bannerHeight = (banner.width() * 450) / 1600 + bannerHeightDelta;
      if (bannerHeight < 240) {
        bannerHeight = 240;
      }
      banner.height(bannerHeight);
    }

    bHeight = (b.width() * 450) / 1600 + bannerHeightDelta;
    if (bHeight < 240) {
      bHeight = 240;
    }
    b.height(bHeight);
  };
  $(document).ready(resizeImages);
  $(window)
    .scroll(() => {
      if ($(window).scrollTop() > 70) {
        $('.header-inner').addClass('sticky-header').css('background-color', headerBackgroundColor);
        $('.header').addClass('sticky-header');
        $('.page-home .header .nav-menu-link span, .page-home .header button, .page-home .header button svg').css('color', navTextColor);
      }

      if ($(window).scrollTop() <= 70) {
        $('.header-inner').removeClass('sticky-header').css('background-color', 'transparent');
        $('.header').removeClass('sticky-header');
        $('.page-home .header .nav-menu-link span, .page-home .header button, .page-home .header button svg').css(
          'color',
          headerPosition.toLowerCase() === 'inner' ? homepageNavTextColor : navTextColor,
        );
      }
    })
    .resize(resizeImages)
    .on('load', resizeImages);
  const isInnerHeader = eq(toLower(headerPosition), 'inner');
  const isNewsTop = eq(newsPosition, 'top');
  let news = '';

  if (showNews && size(compact(feed))) {
    news = <Ticker feed={compact(feed)} position={newsPosition} title={newsTitle} backgroundColor={newsBackgroundColor} />;
  }
  const heroTextDecorationOptions = ['border', 'stripe'];
  const heroTextDecoration = heroTextDecorationOptions[0];
  const heroDecorationColor = { color: textDecorationColor };
  const bannerOpacity = 0.5;
  const eventCategory = [name, planName].join(' - ');

  // const smallScreenBannerHeightStyles = () => {
  //   return isMobile || isTablet
  //   ? {
  //       height: `${bannerHeight > 500 ? 500 : bannerHeight}px`,
  //       ...(bannerHeight
  //         ? {
  //             minHeight: `${bannerHeight > 500 ? 500 : bannerHeight}px`,
  //             maxHeight: `${bannerHeight > 500 ? 500 : bannerHeight}px`,
  //           }
  //         : {}),
  //     }
  //   : {}
  // };

  useEffect(() => {
    if (isPublic) {
      try {
        onPageView({
          variables: { pathname: page, ...(document.referrer && { referrer: document.referrer }) },
          onCompleted() {
            const trackIds = compact(googleTracking);
            const GIds = trackIds.filter((trackingId) => trackingId.startsWith('G-'));
            const UAIds = trackIds.filter((trackingId) => trackingId.startsWith('UA-'));

            if (GIds.length) {
              ga4.initialize(GIds.map((trackingId) => ({ trackingId })));
              ga4.gtag('event', 'page_view', {
                page_title: document.title,
                page_location: window.location.href,
              });
            }

            UAIds.forEach((trackingId) => {
              ReactGA.initialize(trackingId);
              ReactGA.set({ page });
              ReactGA.pageview(page);
            });
          },
        });
      } catch (e) {
        console.error(e);
      }
    }
  }, [page]);

  return (
    <Profiler id="HomePage" onRender={onRender}>
      <title>{settings?.pageTitle || 'Home'}</title>
      <style dangerouslySetInnerHTML={{ __html: cssOverwrite }} />
      <div style={{ display: 'none' }}>
        <FroalaEditor model={''} onModelChange={() => {}} config={{}} />
      </div>
      <div className="page-wrapper">
        <div
          className="page homepage"
          style={{
            fontFamily: `${startCase(camelCase(fontFamily))}`,
            fontSize: parseInt(fontSize, 10),
          }}
        >
          <a href="#main" className="skip-link" aria-label="Skip to main content">
            Skip To Main Content
          </a>
          {!!branding && (
            <Header
              logo={logo}
              logoLink={logoLink}
              linkPrefix={linkPrefix}
              backgroundColor={headerBackgroundColor}
              navItems={navs}
              navTextColor={isInnerHeader ? homepageNavTextColor || navTextColor : navTextColor}
              navPosition={toLower(navPosition)}
              isInnerHeader={isInnerHeader}
              position={newsPosition}
              navs={navs}
              translateProvider={translateProvider}
              corporationName={corporationName}
            />
          )}
          <main id="main">
            {isInnerHeader && isNewsTop ? news : ''}
            {branding && !!hasBanner && (
              <div
                className={`intro uipd-hero`}
                style={{
                  backgroundColor: bannerBackgroundColor,
                  height: `${bannerHeight}px`,
                  // ...smallScreenBannerHeightStyles(),
                }}
              >
                <div
                  className="overlay intro"
                  style={{
                    ...(withImage ? { backgroundImage: `url(${bannerImage})` } : {}),
                    mixBlendMode: imageBlendMode,
                    opacity,
                    backgroundPosition,
                    // ...smallScreenBannerHeightStyles(),
                  }}
                />
                <div className="intro-text uipd-hero-text">
                  <div
                    {...ui([
                      'intro-edit-text',
                      'pd-custom',
                      'uipd-hero-text-main',
                      textDecoration ? `uipd-hero-text-main--${textDecoration}` : '',
                      'fr-view',
                    ])}
                    role="heading"
                    aria-level={1}
                    style={heroDecorationColor}
                  >
                    <FroalaEditorView model={bannerText} />
                  </div>
                </div>
                {!isInnerHeader && isNewsTop ? news : ''}
              </div>
            )}
            {isNewsTop ? '' : news}
            <section aria-label="Intro">
              {introContent.map(({ type: introType, text, backgroundColor }, index) => {
                if (introType === 'status') {
                  const options = {
                    chart: { type: 'pie', width, height: width },
                    title: { text: 'Status Distribution', style: { display: 'none' } },
                    plotOptions: { pie: { innerSize: '70%' }, series: { dataLabels: { enabled: false } } },
                    exporting: { enabled: false },
                    credits: { enabled: false },
                    tooltip: { pointFormat: '{point.percentage:.0f}%' },
                    accessibility: {
                      enabled: true,
                      description: 'Status distribution chart',
                      keyboardNavigation: {
                        enabled: true,
                        order: ['series', 'legend'],
                        wrapAround: true,
                      },
                      series: { describeSingleSeries: true },
                    },
                    legend: {
                      accessibility: {
                        enabled: true,
                        keyboardNavigation: { enabled: true },
                      },
                    },
                    series: [
                      {
                        name: '',
                        data: [
                          ...(showStatusPending && isMeaningful(statusPendingCount)
                            ? [{ name: `${statusPendingLabel}:`, y: statusPendingCount, color: statusPendingColor }]
                            : []),
                          ...(showOnTrack && isMeaningful(onTrackCount)
                            ? [{ name: `${onTrackLabel}:`, y: onTrackCount, color: onTrackColor }]
                            : []),
                          ...(showMinorDisruption && isMeaningful(someDisruptionCount)
                            ? [{ name: `${someDisruptionLabel}:`, y: someDisruptionCount, color: someDisruptionColor }]
                            : []),
                          ...(showMajorDisruption && isMeaningful(majorDisruptionCount)
                            ? [{ name: `${majorDisruptionLabel}:`, y: majorDisruptionCount, color: majorDisruptionColor }]
                            : []),
                          ...(showUpcoming && isMeaningful(upcomingCount)
                            ? [{ name: `${upcomingLabel}:`, y: upcomingCount, color: upcomingColor }]
                            : []),
                          ...(showDiscontinued && isMeaningful(discontinuedCount)
                            ? [{ name: `${discontinuedLabel}:`, y: discontinuedCount, color: discontinuedColor }]
                            : []),
                          ...(showCompleted && isMeaningful(completedCount)
                            ? [{ name: `${completedLabel}:`, y: completedCount, color: completedColor }]
                            : []),
                        ],
                      },
                    ],
                  };

                  return (
                    <article
                      key={join(['intro', 'content', index], '-')}
                      className="health-status"
                      style={{
                        maxWidth: `min(100% - (2 * ${horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : 0}), 1000px)`,
                      }}
                    >
                      {!!options?.series?.[0]?.data?.length && showStatusBar && (
                        <>
                          <div className="health-status-chart" ref={ref}>
                            <HighchartsReact highcharts={Highcharts} options={options} />
                            <span className="health-status-chart-status">Status</span>
                          </div>
                          <table className="health-status-chart-legend">
                            <thead>
                              <tr className="legend-labels">
                                <th className="status" style={{ paddingLeft: '30px' }}>
                                  Status
                                </th>
                                <th className="status percent">%</th>
                              </tr>
                            </thead>
                            <tbody>
                              {showStatusPending && isMeaningful(statusPendingCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle status-pending" />
                                      <span className="nowrap">{statusPendingLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((statusPendingCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                              {showOnTrack && isMeaningful(onTrackCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle on-track" />
                                      <span className="nowrap">{onTrackLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((onTrackCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                              {showMinorDisruption && isMeaningful(someDisruptionCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle some-disruption" />
                                      <span className="nowrap">{someDisruptionLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((someDisruptionCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                              {showMajorDisruption && isMeaningful(majorDisruptionCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle major-disruption" />
                                      <span className="nowrap">{majorDisruptionLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((majorDisruptionCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                              {showUpcoming && isMeaningful(upcomingCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle upcoming" />
                                      <span className="nowrap">{upcomingLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((upcomingCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                              {showDiscontinued && isMeaningful(discontinuedCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle discontinued" />
                                      <span className="nowrap">{discontinuedLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((discontinuedCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                              {showCompleted && isMeaningful(completedCount) && (
                                <tr>
                                  <td className="status-label">
                                    <span className="flex-content">
                                      <span className="status-circle completed" />
                                      <span className="nowrap">{completedLabel}</span>
                                    </span>
                                  </td>
                                  <td className="status percent">{Math.round((completedCount / statusCount) * 100)}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </>
                      )}
                      <div className="progress-chart">
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={{
                            title: { text: 'Progress Gauge', style: { display: 'none' } },
                            exporting: { enabled: false },
                            chart: { type: 'solidgauge', width, height: width },
                            legend: { enabled: false },
                            yAxis: {
                              stops: [[0.1, '#1594c9']],
                              min: 0,
                              max: 100,
                              title: null,
                              lineWidth: 0,
                              minorTickInterval: null,
                              tickAmount: 2,
                              labels: { y: 16 },
                              plotBands: [
                                {
                                  from: overdueCount - 0.5,
                                  to: overdueCount + 0.5,
                                  color: 'blue',
                                  innerRadius: '70%',
                                  outerRadius: '100%',
                                  zIndex: 15,
                                },
                              ],
                            },
                            series: [
                              {
                                data: [progressPercentage],
                                animation: false,
                                dataLabels: {
                                  enabled: false,
                                  // format:
                                  //   '<div style="text-align:center">' +
                                  //   '<span style="font-size:25px">{y}%</span><br/>' +
                                  //   '<span style="font-size:12px;opacity:0.4">Progress</span>' +
                                  //   '</div>',
                                },
                              },
                            ],
                            pane: {
                              center: ['50%', '50%'],
                              size: '100%',
                              startAngle: -90,
                              endAngle: 90,
                              background: { backgroundColor: '#eeeeee', innerRadius: '70%', outerRadius: '100%', shape: 'arc' },
                            },
                            plotOptions: { solidgauge: { innerRadius: '70%', dataLabels: { y: 5, borderWidth: 0, useHTML: true } } },
                            credits: { enabled: false },
                            tooltip: { enabled: false },
                            accessibility: {
                              enabled: true,
                              description: 'Progress gauge chart',
                              keyboardNavigation: { enabled: true, wrapAround: true },
                              series: { describeSingleSeries: true },
                            },
                          }}
                        />
                        <div className="progress-chart-info">
                          <div className="progress-chart-info-percent">{`${Math.round(progressPercentage)}%`}</div>
                          <div>Progress</div>
                        </div>
                      </div>
                    </article>
                  );
                }

                return (
                  <article
                    className={`middle-text-content text-content pd-custom fr-view intro-content${index + 1}`}
                    key={join(['intro', 'content', index], '-')}
                    style={{
                      backgroundColor,
                      paddingLeft: horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : undefined,
                      paddingRight: horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : undefined,
                      maxWidth: horizontalPadding.indexOf('px') >= 0 ? horizontalPadding : undefined,
                    }}
                  >
                    <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                      <FroalaEditorView model={text} />
                    </div>
                  </article>
                );
              })}
            </section>
            <section
              aria-label="Main"
              role="list"
              className={`child-thumbnails-section column-row-${columns}`}
              style={{
                backgroundColor: mainContentBackgroundColor,
                paddingLeft: horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : undefined,
                paddingRight: horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : undefined,
                maxWidth: horizontalPadding.indexOf('px') >= 0 ? horizontalPadding : undefined,
              }}
            >
              {filter(children, ['enable', true]).map((child) => (
                <Card
                  settings={settings}
                  key={child.planNodeId}
                  data={child}
                  linkPrefix={linkPrefix}
                  showCardDescription={showCardDescription || false}
                  overlapCardTitle={overlapCardTitle}
                  showProgress={showProgress}
                  role="listitem"
                />
              ))}
            </section>
            <section aria-label="Sub section">
              {map(subContent, ({ text, backgroundColor }, index) => (
                <article
                  style={{
                    backgroundColor,
                    paddingLeft: horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : undefined,
                    paddingRight: horizontalPadding.indexOf('%') >= 0 ? `${(100 - horizontalPadding.split('%')[0]) / 2}%` : undefined,
                    maxWidth: horizontalPadding.indexOf('px') >= 0 ? horizontalPadding : undefined,
                  }}
                  key={join(['sub', 'content', index], '-')}
                  className={`middle-text-content text-content pd-custom fr-view sub-content${index + 1}`}
                >
                  <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <FroalaEditorView model={text} />
                  </div>
                </article>
              ))}
            </section>
          </main>
        </div>

        {branding ? (
          <Footer
            content={footerContent}
            backgroundColor={footerBackgroundColor || 'rgba(255,255,255,0)'}
            fontFamily={`${startCase(camelCase(fontFamily))}`}
            corporationName={corporationName}
          />
        ) : (
          ''
        )}
      </div>
    </Profiler>
  );
}

Homepage.propTypes = {
  linkPrefix: oneOfType([bool, string]).isRequired,
  branding: bool.isRequired,
  navs: arrayOf(
    shape({
      id: string,
      title: string,
      level: number,
      isMeasure: bool,
      items: arrayOf(shape({})),
      measures: arrayOf(shape({})),
    }),
  ).isRequired,
  data: shape({
    children: arrayOf(shape({ planNodeId: string })),
    banner: shape({
      image: string,
      position: string,
      backgroundColor: string,
      text: string,
      enable: bool,
    }),
    newsFeed: shape({
      feed: arrayOf(string),
      enabled: bool,
      position: string,
      title: string,
      backgroundColor: string,
    }),
    introContent: arrayOf(shape({ text: string, backgroundColor: string, type: string })),
    mainContentBackgroundColor: string,
    columns: number,
    subContent: arrayOf(shape({})),
    headerPosition: string,
    navTextColor: string,
  }).isRequired,
  settings: shape({
    logo: shape({ image: string }),
    logoLink: string,
    headerBackgroundColor: string,
    footer: string,
    footerBackgroundColor: string,
    cssOverwrite: string,
    fontFamily: string,
    fontSize: string,
    horizontalPadding: string,
    navTextColor: string,
    navPosition: string,
  }).isRequired,
};
